import { render, staticRenderFns } from "./Liquidate.vue?vue&type=template&id=3238f4b9&"
import script from "./Liquidate.vue?vue&type=script&lang=js&"
export * from "./Liquidate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports